module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_4.bf405550.png";